import { useContext } from "react";

import { Flex, Box, Image, Text } from "@chakra-ui/react";

import Section from "components/Section";

import { PageContext } from "providers/PageProvider";

const StaderRoadAheadSection = () => {
  const { page } = useContext(PageContext);

  const sectionDetails = page?.data?.pageData?.road_ahead?.section_details;
  const roadAheadData = page?.data?.pageData?.road_ahead?.road_ahead_data || [];

  return (
    <Section title={sectionDetails?.title || ""}>
      <Flex
        gap={{ base: "8px", md: "24px" }}
        maxW="1192px"
        flexWrap="wrap"
        mt="40px"
        justifyContent="center"
        px={{ base: "16px", lg: "0" }}
        pb="60px"
      >
        {roadAheadData.map((data: any, index: number) => (
          <Flex
            padding={{ base: "16px 24px", lg: "24px" }}
            alignItems="center"
            flexDirection={{ base: "row", lg: "column" }}
            borderRadius="16px"
            gap="24px"
            key={index}
            w={{ base: "100%", lg: "381px" }}
            minH={{ base: 0, lg: "254px" }}
          >
            <Image
              src={data.img_key}
              boxSize={{ base: "40px", lg: "64px" }}
              alt={data.title}
            />
            <Box textAlign={{ base: "left", lg: "center" }}>
              <Text
                textStyle={{ base: "h5", lg: "h3" }}
                fontWeight="600 !important"
              >
                {data.title}
              </Text>
              <Text
                textStyle={{ base: "p12", lg: "p14" }}
                fontWeight="500"
                mt="4px"
                color="textSecondary"
              >
                {data.description}
              </Text>
            </Box>
          </Flex>
        ))}
      </Flex>
    </Section>
  );
};

export default StaderRoadAheadSection;
